import { createTheme, responsiveFontSizes } from "@mui/material/styles";

let theme = createTheme();

theme = createTheme({
  // palette: {
  //   secondary: {
  //     main: "#fefefe",
  //   },
  // },
});

theme = responsiveFontSizes(theme);

export default theme;
